import Tick from './tick';

export * from './tick';
export default Tick;
